/**
 * TextItem类需要实现以下功能
 * 1. 相关属性
 *      a. 文本内容:str
 *      b. 文本字体属性:fontData
 *      c. 文本颜色:color
 *      d. 文本原始位置:originPos
 *      e. 文本字体大小:fontSize
 */
// import { rotatePoint } from "../math_utils.js"
export class TextItem {
	constructor(str, fontData, color, originPos, fontSize, bbox = null, rotation = 0, isInlineFormula = false, originCharCodes = [], formulaWidth = 0, originCharCodeWidths = [], charSpacing = 0, indexs = []) {
		this.str = str.replaceAll('\r', '');
		this.fontData = fontData;
		this.color = color;
		this.originPos = originPos;
		this.fontSize = fontSize;
		this.diffY = 0
		this.diffX = 0
		this.bbox = bbox
		this.rotation = rotation
		this.isInlineFormula = isInlineFormula
		// 记录formal的originCharCode
		this.originCharCodes = isInlineFormula ? originCharCodes : []
		this.formulaWidth = isInlineFormula ? formulaWidth : 0
		this.originCharCodeWidths = isInlineFormula ? originCharCodeWidths : []
		this.charSpacing = charSpacing
		// 记录当前的索引信息
		this.indexs = indexs
	}

	// 获取文本内容
	getText(blockData = null) {
		if (blockData && this.isInlineFormula) {
			return `{$${blockData.inlineFormulaIndex ++}}`
		}
		return this.str;
	}

	// 设置文本内容
	setText(newStr) {
		this.str = newStr;
	}

	// 获取fontSize
	getFontSize(){
		return this.fontSize
	}

	// 设置fontSize
	setFontSize(newFontSize) {
		this.fontSize = newFontSize
	}

	// 获取字体属性
	getFontData() {
		return this.fontData;
	}

	// 设置字体属性
	setFontData(newFontData) {
		this.fontData = newFontData;
	}

	// 获取文本颜色
	getColor() {
		return this.color;
	}

	// 设置文本颜色
	setColor(newColor) {
		this.color = newColor;
	}

	// 获取文本原始位置
	getOriginPos() {
		return this.originPos;
	}

	// 设置文本始位置
	setOriginPos(newOriginPos) {
		this.originPos = newOriginPos;
	}

	// 获取diffY
	getDiffY(){
		return this.diffY
	}

	// 设置diffY
	setDiffY(newDiffY){
		this.diffY = newDiffY
	} 

	// 获取diffX
	getDiffX(){
		return this.diffX
	}

	// 设置diffX
	setDiffX(newDiffX){
		this.diffX = newDiffX
	}

	// 获取bbox
	getBbox(){
		return this.bbox
	}

	// 设置bbox
	setBbox(newBbox){
		this.bbox = newBbox
	}

	// 获取rotation
	getRotation(){
		return this.rotation
	}

	// 设置rotation
	setRotation(newRotation){
		this.rotation = newRotation
	}

	// 获取isInlineFormula
	getIsInlineFormula(){
		return this.isInlineFormula
	}

	// 设置isInlineFormula
	setIsInlineFormula(newIsInlineFormula){
		this.isInlineFormula = newIsInlineFormula
	}

	// 获取originCharCodes
	getOriginCharCodes(){
		return this.originCharCodes
	}
	
	// 获取formulaWidth
	getFormulaWidth(){
		return this.formulaWidth
	}

	// 获取charSpacing
	getCharSpacing(){
		return this.charSpacing
	}

	// 与另一个TextItem进行比较，比较内容如下：1. 颜色是否一致，2. 字体大是否比较接近，比如相差不超过5%，3. fontData是否一致，fontData里面是一个对象{"black":false,"bold":false,"italic":false,"light":false,"extraBold":false,"extraLight":false,"medium":false,"semiBold":false,"thin":false}
	compare(otherItem) {
		// 1. 比较颜色是否一致
		const colorMatch = JSON.stringify(this.color) === JSON.stringify(otherItem.color);
		
		// 2. 比较字体大小是否接近（相差不超过5%）
		const fontSizeDiff = Math.abs(this.fontSize - otherItem.fontSize) / this.fontSize;
		const fontSizeMatch = fontSizeDiff <= 0.05;
		
		// 3. 比较fontData是否一致
		const fontDataKeys = ["black", "bold", "italic", "light", "extraBold", "extraLight", "medium", "semiBold", "thin", "fontName"];
		const fontDataMatch = fontDataKeys.every(key => this.fontData[key] === otherItem.fontData[key]);
		// 4. 比较是否是行内公式
		const isInlineFormulaMatch = this.isInlineFormula === otherItem.isInlineFormula
		// 5. 比较charSpacing是否一致
		const charSpacingMatch = this.charSpacing === otherItem.charSpacing
		return colorMatch && fontSizeMatch && fontDataMatch && isInlineFormulaMatch && charSpacingMatch || otherItem.str.trim().length === 0;
	}

	// 实现合并textItem的方法,先调用compare方法，如果一致，则将两个textItem的str拼接起来
	merge(otherItem, isAddLeft) {
		if (this.compare(otherItem)) {
			if (isAddLeft) {
				this.str = otherItem.str + this.str;
				this.originCharCodes = [...otherItem.originCharCodes, ...this.originCharCodes]
				this.originCharCodeWidths = [...otherItem.originCharCodeWidths, ...this.originCharCodeWidths]
				this.indexs = [...otherItem.indexs, ...this.indexs]
			} else {
				this.str += otherItem.str;
				this.originCharCodes = [...this.originCharCodes, ...otherItem.originCharCodes]
				this.originCharCodeWidths = [...this.originCharCodeWidths, ...otherItem.originCharCodeWidths]
				this.indexs = [...this.indexs, ...otherItem.indexs]
			}
			this.formulaWidth += otherItem.formulaWidth
			return true
		} else {
			return false
		}
	}

	// 复制一个自己
	copy(){
		const item = new TextItem(this.str, this.fontData, this.color, this.originPos, this.fontSize, this.bbox, this.rotation, this.isInlineFormula, this.originCharCodes, this.formulaWidth, this.originCharCodeWidths, this.charSpacing, this.indexs)
		item.setDiffY(this.diffY)
		item.setDiffX(this.diffX) 
		return item
	}
}

/**
 * TextLine需要实现以下功能
 * 1. 相关属性
 *  a. TextItem数组:items
 * 2. 实现getLineStr方法，基于items数组，将每个item的文本内容拼接起来，除了第一个以外，其他都会增加一个\t
 * 
 */
export class TextLine {
	constructor(items = []) {
		this.items = items;
	}

	// 获取TextItem数组
	getItems() {
		return this.items;
	}

	// 设置TextItem数组
	setItems(newItems) {
		this.items = newItems;
	}

	// 实现getLineStr方法
	getLineStr(blockData = null) {
		if (this.items.length === 0) {
			return '';
		}

		let result = this.items[0].getText(blockData);
		for (let i = 1; i < this.items.length; i++) {
			result += '\\t' + this.items[i].getText(blockData);
		}
		return result;
	}

	// 获取最后一个TextItem
	getLastItem() {
		return this.items[this.items.length - 1];
	}

	// 添加TextItem
	addItem(item, isAddLeft) {
		if (isAddLeft) {
			// 当isAddLeft为true时，item需要插入到items最后一个的前面
			this.items.splice(this.items.length - 1, 0, item);
		} else {
			this.items.push(item);
		}
	}
	// 获取items里面的出现最多的fontSize
	getMostCommonFontSize() {
		// const fontSizes = this.items.map(item => item.getFontSize());
		const fontSizeCount = {};
		let maxCount = 0;
		let mostCommonFontSize = null;

		for (const item of this.items) {
			const fontSize = item.getFontSize()
			fontSizeCount[fontSize] = (fontSizeCount[fontSize] || 0) + item.getText().length;
			if (fontSizeCount[fontSize] > maxCount) {
				maxCount = fontSizeCount[fontSize];
				mostCommonFontSize = fontSize;
			}
		}

		return mostCommonFontSize;
	}
	// 获取items里面的出现最多的字体颜色
	getMostCommonColor() {
		const colors = this.items.map(item => item.getColor());
		const colorCount = {};
		let maxCount = 0;
		let mostCommonColor = null;

		for (const color of colors) {
			colorCount[color] = (colorCount[color] || 0) + 1;
			if (colorCount[color] > maxCount) {
				maxCount = colorCount[color];
				mostCommonColor = color;
			}
		}

		return mostCommonColor;
	}

	// 刷新所有的items的diffY，刷星方法为，先找出最小的originPos的y值，然后遍历所有的items，将每个item的originPos的y值减去最小的originPos的y值，然后将结果赋值给diffY
	// refreshDiffY(textAngle){
	//   // 修改逻辑找出出现最多的y轴的值
	//   // const yValues = this.items.map(item => item.getOriginPos()[1]);
	//   // const yValueCount = {};
	//   // let maxCount = 0;
	//   // let mostCommonYValue = null;

	//   // for (const y of yValues) {
	//   //   yValueCount[y] = (yValueCount[y] || 0) + 1;
	//   //   if (yValueCount[y] > maxCount) {
	//   //     maxCount = yValueCount[y];
	//   //     mostCommonYValue = y;
	//   //   }
	//   // }
	//   // 需要旋转角度，旋转完之后，需要计算出旋转后的y轴的值
	//   // 获取第一个item的originPos的值
	//   const firstItem = this.items[0]
	//   const originPos = firstItem.getOriginPos()
	//   const allPos = []
	//   for (let item of this.items) {
	//     const rotatedPos = rotatePoint(item.getOriginPos(), originPos, -textAngle * Math.PI / 180)
	//     allPos.push(rotatedPos)
	//   }
	//   let minOriginPosY = Math.min(...allPos.map(pos => pos[1]));
	//   this.items.forEach((item, index) => {
	//     item.setDiffY(allPos[index][1] - minOriginPosY);
	//   })
	// } 
	// // 刷新所有的items的diffX，刷星方法为，先找出最小的originPos的x值，然后遍历所有的items，将每个item的originPos的x值减去最小的originPos的x值，然后将结果赋值给diffX
	// refreshDiffX(textAngle){
	//   // 需要旋转角度，旋转完之后，需要计算出旋转后的y轴的值
	//   // 获取第一个item的originPos的值
	//   const firstItem = this.items[0]
	//   const originPos = firstItem.getOriginPos()
	//   const allPos = []
	//   for (let item of this.items) {
	//     const rotatedPos = rotatePoint(item.getOriginPos(), originPos, -textAngle * Math.PI / 180)
	//     allPos.push(rotatedPos)
	//   }
	//   let minOriginPosX = Math.min(...allPos.map(pos => pos[0]));
	//   this.items.forEach((item, index) => {
	//     item.setDiffX(allPos[index][0] - minOriginPosX);
	//   })
	// }
	// 检查是否只有一个字符
	checkIsOnlyOne(){
		return this.getLineStr().length === 1
	}
	// 获取所有的行内公式item
	getInlineFormulaItems(){
		let result = []
		for (let item of this.items) {
			if (item.getIsInlineFormula()) {
				result.push(item) 
			}
		}
		return result
	}
}

export class TextBlock {
	constructor(lines = []) {
		this.lines = lines;
	}

	// 获取TextLine数组
	getLines() {
		return this.lines;
	}

	// 获取最后一个TextLine
	getLastLine() {
		return this.lines[this.lines.length - 1];
	}
	// 添加TextLine
	addLine(line) {
		this.lines.push(line);
	}
	// 获取所有文本信息
	getAllTexts() {
		let blockData = {
			inlineFormulaIndex: 0
		}
		const allTexts = []
		for (let line of this.lines) {
			allTexts.push(line.getLineStr(blockData))
		}
		return allTexts.join('\\n');
	}
	// 获取所有需要以\\t分割的item数组
	// getNeedSplitItems(textAngle){
	//   let result = []
	//   for (let line of this.lines) {
	//     line.refreshDiffY(textAngle)
	//     line.refreshDiffX(textAngle)
	//     let items = line.getItems()
	//     // result最后一个和items第一个进行compare，不相同的时候比较text的长度，取最长的
	//     if (result.length > 0 && !result[result.length - 1].compare(items[0])) {
	//       if (result[result.length - 1].getText().length < items[0].getText().length) {
	//         result[result.length - 1] = items[0]
	//       }
	//     }
	//     for (let i = 1; i < items.length; i ++) {
	//       result.push(items[i])
	//     }
	//   }
	//   return result
	// }
	// 获取合并后的items
	getMergedItems(){
		let result = []
		let lastItem = null
		for (let line of this.lines) {
			for (let item of line.getItems()) {
				const copyItem = item.copy()
				if (lastItem && lastItem.compare(copyItem)) {
					lastItem.merge(copyItem, true)
				} else {
					result.push(copyItem)
					lastItem = copyItem
				}
			}
		}
		if (lastItem) {
			result.push(lastItem)
		}
		return result
	}
	// 获取出现最多的fontSize
	getMostCommonFontSize() {
		return this.lines.map(line => line.getMostCommonFontSize()).sort((a, b) => a - b)[0];
	}
	// 获取所有的行内公式item
	getInlineFormulaItems(){
		let result = []
		for (let line of this.lines) {
			result.push(...line.getInlineFormulaItems())
		}
		return result
	}
}

// 提供一个方法把json内容转换成TextBlock
export function jsonToTextBlock(jsonContent) {
	if (jsonContent === undefined) {
		return 
	}
	const textBlock = new TextBlock();
	
	for (const lineData of jsonContent.lines) {
		const textLine = new TextLine();
		
		for (const itemData of lineData.items) {
			const textItem = new TextItem(
				itemData.str,
				itemData.fontData,
				itemData.color,
				itemData.originPos,
				itemData.fontSize,
				itemData.bbox,
				itemData.rotation,
				itemData.isInlineFormula,
				itemData.originCharCodes,
				itemData.formulaWidth,
				itemData.originCharCodeWidths,
				itemData.charSpacing,
				itemData.indexs
			);
			textLine.addItem(textItem);
		}
		
		textBlock.addLine(textLine);
	}
	
	return textBlock;
}